import restApi from "../../http.js";
import session from "../session.js";

export default class VideoApi {
  getVideoUploadUrl(productId) {
    return restApi({
      method: "POST",
      url: `/products/${productId}/video-url`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  getAssetId(uploadId) {
    return restApi({
      method: "GET",
      url: `/videos/${uploadId}/poll-for-playback-ids`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  setVideo(productId, data) {
    return restApi({
      method: "POST",
      url: `/products/${productId}/video`,
      data: {
        entity_type: "PRODUCT",
        url: data.url,
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
  deleteVideo(videoId) {
    return restApi({
      method: "DELETE",
      url: `/videos/${videoId}`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
